import { render, staticRenderFns } from "./SupportPointTable.vue?vue&type=template&id=0b2bbe49"
import script from "./SupportPointTable.vue?vue&type=script&lang=ts"
export * from "./SupportPointTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b2bbe49')) {
      api.createRecord('0b2bbe49', component.options)
    } else {
      api.reload('0b2bbe49', component.options)
    }
    module.hot.accept("./SupportPointTable.vue?vue&type=template&id=0b2bbe49", function () {
      api.rerender('0b2bbe49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/SupportPointTable.vue"
export default component.exports